import {Injectable} from "@angular/core";
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";

/**
 * Strips `clip-path="url(#...)"` attributes and their corresponding `<defs>` blocks from
 * inlined SVG icons fetched by Angular Material's MatIconRegistry.
 *
 * Background: Figma-exported SVGs often contain no-op clip paths that match the SVG viewBox.
 * When Angular Material inlines these SVGs into the DOM, browsers resolve the fragment-only
 * `url(#clipId)` references relative to the current document URL (e.g. `/my-profiles/3955`),
 * triggering a spurious GET request and a 404 error.
 */
@Injectable({
	providedIn: "root",
})
export class SvgClipPathInterceptor implements HttpInterceptor {
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			map((event) => {
				if (event instanceof HttpResponse && req.url.endsWith(".svg")) {
					const body = event.body as string;
					if (typeof body === "string" && body.includes('clip-path="url(#')) {
						const cleaned = body
							.replace(/ clip-path="url\(#[^"]+\)"/g, "")
							.replace(/<defs>\s*<clipPath[^>]*>[\s\S]*?<\/clipPath>\s*<\/defs>/g, "");
						return event.clone({body: cleaned});
					}
				}
				return event;
			}),
		);
	}
}
